import Cookies from 'js-cookie'

const IsSubmitKey = 'issubmit'
const IdKey = 'id'
const SubjectIdKey = 'subject_id'
const LevelIdKey = 'level_id'
const MemberIdKey = 'member_id'

export function getIsSubmit() {
  return Cookies.get(IsSubmitKey)
}

export function setIsSubmit(IsSubmit) {
  return Cookies.set(IsSubmitKey, IsSubmit)
}

export function removeIsSubmit() {
  return Cookies.remove(IsSubmitKey)
}

export function getId() {
  return Cookies.get(IdKey)
}

export function setId(Id) {
  return Cookies.set(IdKey, Id)
}

export function removeId() {
  return Cookies.remove(IdKey)
}

export function getSubjectId() {
  return Cookies.get(SubjectIdKey)
}

export function setSubjectId(SubjectId) {
  return Cookies.set(SubjectIdKey, SubjectId)
}

export function removeSubjectId() {
  return Cookies.remove(SubjectIdKey)
}

export function getLevelId() {
  return Cookies.get(LevelIdKey)
}

export function setLevelId(LevelId) {
  return Cookies.set(LevelIdKey, LevelId)
}

export function removeLevelId() {
  return Cookies.remove(LevelIdKey)
}

export function getMemberId() {
  return Cookies.get(MemberIdKey)
}

export function setMemberId(MemberId) {
  return Cookies.set(MemberIdKey, MemberId)
}

export function removeMemberId() {
  return Cookies.remove(MemberIdKey)
}
